module.exports = __webpack_public_path__ + "img/122.d4d87d1d.jpg";